import { render, staticRenderFns } from "./shipinjianjizhong.vue?vue&type=template&id=d289581c&scoped=true"
import script from "./shipinjianjizhong.vue?vue&type=script&lang=js"
export * from "./shipinjianjizhong.vue?vue&type=script&lang=js"
import style0 from "./shipinjianjizhong.vue?vue&type=style&index=0&id=d289581c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d289581c",
  null
  
)

export default component.exports